import script from "./BookingVehicleCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingVehicleCard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__